"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3874],{

/***/ 73874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_ProductDetailsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 206 modules
var AemGrid = __webpack_require__(94020);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./components/ProductDetail/v3/productDetailsHelper.js
var productDetailsHelper = __webpack_require__(14887);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./utils/productImageHelper.js

/**
 * Processes variant images for a product and extracts initial image data
 * @param {Object} pdpData - Product data from server
 * @param {string} skuId - SKU ID to process images for
 * @return {Object} Object containing variantImages, initialImgAlt, initialImgUrl, initialImageFullUrl
 */ const processVariantImages = (pdpData, skuId)=>{
    let variantImages = [];
    let initialImgAlt = "";
    let initialImgUrl = "";
    let initialImageFullUrl = "";
    if (!skuId || !pdpData) {
        return {
            variantImages,
            initialImgAlt,
            initialImgUrl,
            initialImageFullUrl
        };
    }
    let variants = [];
    if (pdpData["variantList.sku_ss"]) {
        variants = pdpData["variantList.sku_ss"];
    }
    variantImages = pdpData["productImages.labelWithUrl_ss"] ? pdpData["productImages.labelWithUrl_ss"] : [];
    let variantImageLabels = [];
    let variantImageURLs = [];
    if (variantImages === null || variantImages === void 0 ? void 0 : variantImages.length) {
        const selVarImageUrls = [];
        const selVarImageLabels = [];
        variantImages.forEach((img)=>{
            const imgDetail = img.split("|");
            if (skuId === imgDetail[0]) {
                var ref;
                selVarImageLabels.push((ref = imgDetail[4]) !== null && ref !== void 0 ? ref : "");
                selVarImageUrls.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : constants.EMPTY_PIXEL);
            } else if (!variants.find((v)=>v === imgDetail[0])) {
                var ref1;
                variantImageLabels.push((ref1 = imgDetail[4]) !== null && ref1 !== void 0 ? ref1 : "");
                variantImageURLs.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : constants.EMPTY_PIXEL);
            }
        });
        variantImageLabels = [
            ...selVarImageLabels,
            ...variantImageLabels
        ];
        variantImageURLs = [
            ...selVarImageUrls,
            ...variantImageURLs
        ];
        if (variantImageURLs.length < 1) {
            variantImageLabels.push(skuId);
            variantImageURLs.push(constants.EMPTY_PIXEL);
        }
    } else {
        variantImageLabels.push(skuId);
        variantImageURLs.push(constants.EMPTY_PIXEL);
    }
    const assetIdArray = variantImageURLs ? variantImageURLs[0].split("PAWEB/") : [
        ""
    ];
    initialImgAlt = variantImageLabels[0];
    initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : "";
    var ref;
    initialImageFullUrl = (ref = variantImageURLs.find((image)=>image.includes(initialImgUrl))) !== null && ref !== void 0 ? ref : "";
    return {
        variantImages,
        initialImgAlt,
        initialImgUrl,
        initialImageFullUrl
    };
};

// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 112 modules
var GlobalPageHeader = __webpack_require__(92058);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetail.jsx + 53 modules
var ProductDetail = __webpack_require__(4637);
// EXTERNAL MODULE: ./components/PairsWellWith/PairsWellWith.jsx + 1 modules
var PairsWellWith = __webpack_require__(32046);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(30534);
// EXTERNAL MODULE: ./components/Review/v1/Review.jsx + 2 modules
var Review = __webpack_require__(93330);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductLandingTeasers/ProductExf.jsx
var ProductExf = __webpack_require__(97463);
// EXTERNAL MODULE: ./components/ProductDetail/v3/PDPLoader/index.jsx
var PDPLoader = __webpack_require__(2535);
// EXTERNAL MODULE: ./components/core/Head/NextHead.jsx
var NextHead = __webpack_require__(20812);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/PDPCuratedProducts/index.jsx
var PDPCuratedProducts = __webpack_require__(25762);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/ImageGallery/v2/constants.js
var v2_constants = __webpack_require__(75671);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/ProductDetailsPage.jsx





























/**
 * renders ProductDetailsPage page
 * @param {Object} props - The component props
 * @return {JSX.Element}
 */ function ProductDetailsPage(props) {
    var ref, ref1;
    const { pageModelData ={} , header , footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , slug , skuId , type , pdpData , fullUrl , isPart , siteName , seoProperties: { email ="" , phoneNum =""  } = {} , reviewStatsData , fullReviewData  } = props || {};
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { isTeaserLoaded  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const [pageRedirect, setPageRedirect] = (0,react.useState)("");
    const { redirectTarget: { page: { path =""  } = {}  } = {}  } = pageModelData;
    const [config, setConfig] = (0,react.useState)({});
    const [priceSpiderKey, setPriceSpiderKey] = (0,react.useState)("");
    const [priceSpiderLanguage, setPriceSpiderLanguage] = (0,react.useState)("");
    const [priceSpiderCountry, setPriceSpiderCountry] = (0,react.useState)("");
    const { primaryBundleSKU_s: primaryBundleSKUs = "" , productRegionAllVariantDiscontinued_b: discontinuedProduct = false  } = pdpData;
    const isBundleProduct = Boolean(primaryBundleSKUs);
    // Process variant images using the reusable utility function
    const { variantImages , initialImgAlt , initialImgUrl , initialImageFullUrl  } = (0,react.useMemo)(()=>processVariantImages(pdpData, skuId), [
        pdpData,
        skuId
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>setConfig(config));
        scrollToTop();
        const { ProductLocalCategory_s: productLocalCategory = "" , Product_Category: productCategory = "" , CustomerFacingSKU_s: skuID = "" , CustomerFacingBrand_s: siteName = ""  } = pdpData;
        window.needPdpdata = {
            productSubCatergory: (productLocalCategory === null || productLocalCategory === void 0 ? void 0 : productLocalCategory.toLowerCase()) || (productCategory === null || productCategory === void 0 ? void 0 : productCategory.toLowerCase()),
            skuID,
            siteName: siteName.toLowerCase()
        };
        if (gbhDataLayerCustom) dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
    }, []);
    (0,react.useEffect)(()=>{
        window.adobeTarget = window.adobeTarget || {};
        window.adobeTarget.pdp = {
            variantImages: variantImages
        };
    }, [
        variantImages
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            const psKey = get_default()(config, "general.priceSpiderKey", "");
            if (psKey) {
                setPriceSpiderKey(psKey);
            }
            const psLanguage = get_default()(config, "internationalization.language", "");
            if (psLanguage) {
                setPriceSpiderLanguage(psLanguage);
            }
            const psCountry = get_default()(config, "internationalization.country", "");
            if (psCountry) {
                setPriceSpiderCountry(psCountry);
            }
        }
    }, [
        config
    ]);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (analyticsData) (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    if ( true && ((ref = window.kohler) === null || ref === void 0 ? void 0 : (ref1 = ref.datalayer) === null || ref1 === void 0 ? void 0 : ref1.readyState) === "ready") {
        const kohlerDatalayer = window.kohler.datalayer;
        if (analyticsData && (kohlerDatalayer === null || kohlerDatalayer === void 0 ? void 0 : kohlerDatalayer.setItem)) {
            kohlerDatalayer.setItem("PAGE_INFO", analyticsData);
        }
    }
    (0,react.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,helper/* removeAndCleanLink */.xEh)(path));
        }
    }, [
        path
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react.useEffect)(()=>{
        if (pdpData && accessToken && pageIsInteractive && !isTeaserLoaded) {
            (0,productDetailsHelper/* getTeaserFragments */.lX)(pageModelData, pdpData);
        }
    }, [
        accessToken,
        pdpData,
        pageIsInteractive,
        isTeaserLoaded
    ]);
    const scrollToTop = ()=>{
        window.scrollTo(0, 0);
    };
    const { language: metaLanguage = ""  } = pageModelData;
    const quickViewAuthData = (0,helper/* getQuickViewAuth */.sKe)(footer);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* default */.Z, {
                psKey: priceSpiderKey,
                psCountry: priceSpiderCountry,
                psLanguage: priceSpiderLanguage,
                fullUrl: fullUrl,
                metaLanguage: metaLanguage,
                pdpData: pdpData,
                reviewStatsData: reviewStatsData,
                fullReviewData: fullReviewData,
                isPart: isPart,
                initialImageFullUrl: initialImageFullUrl,
                skuId: skuId,
                siteName: siteName,
                isBundleProduct: isBundleProduct,
                persona: (0,helper/* getUserPersona */.shu)(),
                config: config
            }),
            header ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader["default"], {
                themeType: pageModelData === null || pageModelData === void 0 ? void 0 : pageModelData.appliedCssClassNames,
                header: header,
                title: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaTitle_s,
                description: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaDescription_s,
                templateName: pageModelData === null || pageModelData === void 0 ? void 0 : pageModelData.templateName,
                globalScripting: globalScript,
                isPdp: true,
                fullUrl: fullUrl,
                imageUrl: initialImageFullUrl,
                email: email,
                phone: phoneNum,
                siteName: siteName,
                data: pageModelData
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "zoomdatapdp",
                src: "".concat(v2_constants/* SCENE7_JS_URL */.e5, "ZoomViewer.js")
            }, "zoomdatapdp"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                src: "".concat(v2_constants/* SCENE7_JS_URL */.e5, "SpinViewer.js")
            }),
            pageModelData && !isEmpty_default()(pdpData) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-vh-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid["default"], {
                    data: pageModelData,
                    count: 0,
                    productDetail: (data, slug, skuId, type)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetail/* default */.Z, {
                            data: data,
                            pdpData: pdpData,
                            slug: slug,
                            skuId: skuId,
                            type: type,
                            initialImgAlt: initialImgAlt,
                            initialImgUrl: initialImgUrl,
                            analyticsData: analyticsData
                        }),
                    productDetailFiller: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PDPLoader/* default */.Z, {
                            initialImgAlt: initialImgAlt,
                            initialImgUrl: initialImgUrl,
                            pdpJson: data,
                            pdpData: pdpData,
                            skuId: skuId
                        }),
                    pairsWellWith: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PairsWellWith/* default */.Z, {
                            data: data,
                            skuId: skuId
                        }),
                    productAccordion: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
                            data: data
                        }),
                    review: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Review/* default */.Z, {
                            data: data
                        }),
                    productExf: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductExf/* default */.Z, {
                            data: data
                        }),
                    slug: slug,
                    skuId: skuId,
                    type: type,
                    pdpCuratedProduct: (data)=>!discontinuedProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PDPCuratedProducts/* default */.Z, {
                            authData: data,
                            slug: slug,
                            skuId: skuId,
                            quickViewAuthData: quickViewAuthData
                        }) : null
                })
            }) : null,
            footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter["default"], {
                footer: footer,
                footerScripting: footerScript
            }) : null
        ]
    });
}
ProductDetailsPage.propTypes = {
    reviewStatsData: (prop_types_default()).object,
    fullReviewData: (prop_types_default()).object
};
/* harmony default export */ var components_ProductDetailsPage = (ProductDetailsPage);


/***/ })

}]);